import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  private readonly ignoredURL = 'assets';

  setLoading(value: boolean, url: string) {
    if (!url.includes(this.ignoredURL)) {
      this.isLoadingSubject.next(value);
    }
  }
}
